// extracted by mini-css-extract-plugin
export default {"List":"DurationList_List__cdrWn"};